import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "@/components/Toast";
import { ArrowLeft } from "lucide-react";
import { REQUEST_STATUS_LABEL, REQUEST_TYPE_LABEL } from "@/lib/i18n";

// Fix AA (2026-09-17): se saca "Adelanto de sueldo" a pedido del cliente.
// Los adelantos se gestionan fuera de esta plataforma (app Naaloo). Las
// solicitudes de tipo "adelanto" YA CARGADAS se siguen mostrando con su
// etiqueta (ver REQUEST_TYPE_LABEL); lo que se quita es la posibilidad de
// crear nuevas.
const TYPES = [
  { v: "material", l: "Pedido de material" },
  { v: "refuerzo_compra", l: "Refuerzo / compras" },
  { v: "cambio_personal", l: "Cambio de personal" },
  { v: "otro", l: "Otro" },
];

export default function VigiladorRequests() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ type: "material", description: "", amount: "" });
  const [busy, setBusy] = useState(false);

  const load = async () => {
    try { const { data } = await api.get("/internal-requests"); setList(data); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const payload = { type: form.type, description: form.description, amount: form.amount ? parseFloat(form.amount) : null };
      await api.post("/internal-requests", payload);
      toast.success("Solicitud enviada a Supervisor y administración");
      setForm({ type: "material", description: "", amount: "" });
      load();
    } catch (e2) { toast.error(formatApiError(e2)); }
    finally { setBusy(false); }
  };

  return (
    <div style={{ padding: "8px 16px" }}>
      <Link to="/vigilador" style={{ display: "inline-flex", alignItems: "center", gap: 6, color: "var(--invict-text-muted)", fontSize: 12, marginBottom: 12, textDecoration: "none", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em" }}><ArrowLeft size={14}/> Volver</Link>
      <h1 style={{ fontSize: 26, fontWeight: 900, margin: "4px 0 18px", color: "#0A0A0A", letterSpacing: "-0.02em" }}>Solicitudes</h1>

      <form className="card" style={{ marginBottom: 18, padding: 16 }} onSubmit={submit} data-testid="vig-req-form">
        <div className="field"><label>Tipo</label>
          <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} data-testid="vig-req-type">
            {TYPES.map((t) => <option key={t.v} value={t.v}>{t.l}</option>)}
          </select>
        </div>
        {["adelanto", "refuerzo_compra"].includes(form.type) && (
          <div className="field"><label>Monto estimado (ARS)</label>
            <input type="number" min="0" step="100" value={form.amount} onChange={(e) => setForm({ ...form, amount: e.target.value })} placeholder="ej. 50000" data-testid="vig-req-amount"/>
          </div>
        )}
        <div className="field"><label>Descripción *</label>
          <textarea required value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} placeholder="Detallá qué necesitás..." data-testid="vig-req-desc"/>
        </div>
        <button type="submit" className="btn-primary" disabled={busy} style={{ width: "100%", padding: 12 }} data-testid="vig-req-submit">{busy ? "Enviando..." : "Enviar solicitud"}</button>
      </form>

      <div style={{ fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", color: "#0A0A0A", marginBottom: 10 }}>Mis solicitudes</div>
      <div className="card" style={{ padding: 0, overflow: "hidden" }}>
        {list.length === 0 && <div style={{ padding: 20, textAlign: "center", color: "var(--invict-text-muted)", fontSize: 13 }}>Sin solicitudes enviadas.</div>}
        {list.map((r) => (
          <div key={r.id} style={{ padding: "12px 16px", borderBottom: "1px solid var(--invict-bone-3)" }} data-testid={`vig-req-row-${r.id}`}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, marginBottom: 4 }}>
              <span className="badge gray">{REQUEST_TYPE_LABEL[r.type] || r.type}</span>
              <span className={`badge ${r.status === "pendiente" ? "amber" : r.status === "aprobada" ? "green" : "red"}`}>{REQUEST_STATUS_LABEL[r.status] || r.status}</span>
            </div>
            <div style={{ fontSize: 13, color: "#0A0A0A" }}>{r.description}</div>
            {r.amount && <div style={{ fontSize: 12, color: "#BF3437", fontWeight: 700, marginTop: 2 }}>ARS {Number(r.amount).toLocaleString("es-AR")}</div>}
            {r.admin_response && <div style={{ fontSize: 11, color: "var(--invict-text-muted)", marginTop: 4, fontStyle: "italic" }}>Respuesta: {r.admin_response}</div>}
            <div style={{ fontSize: 10, color: "var(--invict-text-muted)", marginTop: 4 }}>{new Date(r.created_at).toLocaleString("es-AR")}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
